import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function register({token_auth, rfc, name, middle_name, maternal_name, paternal_name, email, budget_keys}) {
  const resource = `/fas/register_request_no_debts`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    name: name,
    middle_name: middle_name,
    maternal_name: maternal_name,
    paternal_name: paternal_name,
    email: email,
    budget_keys: budget_keys
  }
  
  return post(API_URL, params, config)
}

function accept(token_auth, no_debt_certificate_id) {
  const resource = `/fas/accept_request_no_debts`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: no_debt_certificate_id
  }
  
  return post(API_URL, params, config)
}

function reject(token_auth, no_debt_certificate_id) {
  const resource = `/fas/reject_request_no_debts`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: no_debt_certificate_id
  }
  
  return post(API_URL, params, config)
}

function generateCertificate(token_auth, business, no_debt_certificate_id, sheets) {
  const resource = `/fas/generate_certificate`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    business: business,
    no_debt_certificate_id: no_debt_certificate_id,
    sheets: sheets
  }
  
  return post(API_URL, params, config)
}

function getBy(token_auth) {
  const resource = `/fas/get_no_debt_certificate`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth
  }
  
  return get(API_URL, { params, config })
}

function getAcceptedCertificates(token_auth) {
  const resource = `/fas/get_no_debt_certificate_generated`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth
  }
  
  return get(API_URL, { params, config })
}

function getRejectedCertificates(token_auth) {
  const resource = `/fas/get_no_debt_certificate_rejected`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth
  }
  
  return get(API_URL, { params, config })
}

function getCertificateDocument(token_auth, no_debt_certificate_id) {
  const resource = `/fas/get_link_certificate`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: no_debt_certificate_id
  }
  
  return get(API_URL, { params, config })
}

function getAllRequest (token_auth) {
    
  const resource = `/fas/no_debt_certificate/get_all`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth
  }
  
  return get(API_URL, { params, config })
}

export {
  register,
  accept,
  reject,
  generateCertificate,
  getBy,
  getAcceptedCertificates,
  getRejectedCertificates,
  getCertificateDocument,
  getAllRequest,
}